export default {
  contacts: (state) => {
    return state.contacts || [];
  },
  contactsLoading: (state) => {
    return state.contactsLoading;
  },
  contactsInfo: (state) => {
    return state.contactsInfo;
  },
  singleContact: (state) => {
    return (contactId) => {
      return (state.contacts || []).find((i) => i.con_id === contactId);
    };
  },
  activeContact: (state) => {
    return (contactId) => {
      if (contactId === state.activeContact?.con_id) {
        return state.activeContact;
      }
      return null;
    };
  },
  contactLoading: (state) => {
    return state.contactLoading;
  },
  contactsImportStatus: (state) => {
    return state.contactsImportStatus;
  },
  invitedContacts: (state) => {
    return state.invitedContacts || [];
  },
  suggestionsLoading: (state) => {
    return state.suggestionsLoading;
  },
  boardsLoaded: (state) => {
    return state.boardsLoaded;
  },
  boards: (state) => {
    return state.boards;
  },
  boardsConfig: (state) => {
    return state.boardsConfig;
  },
};
